import { Button } from "@mui/material";
import { styled } from "@mui/system";

const OutlinedButton = styled(Button)(({ theme }) => ({
  border: theme.bordered ? `2px solid ${theme.palette.secondary.main}` : "none",
  boxShadow: theme.bordered ? "none" : theme.shadows[2],
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.spacing(0.5),
  fontWeight: 700,
  color: theme.palette.accent.main,
  "&:hover": {
    backgroundColor: theme.palette.grey[100],
    border: theme.bordered ? `2px solid ${theme.palette.secondary.main}` : "none",
    boxShadow: theme.shadows[2],
  },
}));

export default OutlinedButton;
